import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogTitle,
} from '@/components/design-system/Dialog';
import { Button } from '@/components/design-system/Button';

interface DOBConfirmationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  year: number;
  onConfirm: () => void;
  onReject: () => void;
}

export const DOBConfirmationDialog: React.FC<DOBConfirmationDialogProps> = ({
  open,
  onOpenChange,
  year,
  onConfirm,
  onReject,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogTitle className="text-center typography-h3 text-primary fs-mask">
          You entered a birth year of {year}. Is this correct?
        </DialogTitle>
        <DialogFooter className="flex flex-col gap-3 sm:flex-col sm:space-x-0 mt-6">
          <Button
            variant="default"
            onClick={onConfirm}
            className="w-full"
          >
            Yes
          </Button>
          <Button
            variant="secondary-gray"
            onClick={onReject}
            className="w-full"
          >
            No
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
